/* ═══════════════════════════════════════════════════════════════
   SORISSE — sorisse-shop.js
   Replaces the static site's localStorage bag with the real Shopify
   cart. Loads after sorisse.js and takes over the same elements, so
   every animation and the drawer's look stay exactly as designed.

   The drawer, the bag count and checkout run on every page.
   The buy panel only runs where the offer blob was rendered.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) {
    return 'A$' + (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  };

  var data = null;
  var blob = document.getElementById('sorisse-shop-data');
  if (blob) { try { data = JSON.parse(blob.textContent); } catch (e) { data = null; } }

  /* ═══ the drawer, painted from Shopify's own cart ═══════════════ */

  function render(cart) {
    var count = $('#bagCount');
    if (count) {
      count.textContent = cart.item_count;
      count.classList.toggle('on', cart.item_count > 0);
    }

    var body = $('#cartBody');
    if (body) {
      if (!cart.items.length) {
        body.innerHTML = '<p class="cart__empty">Your bag is empty.</p>';
      } else {
        body.innerHTML = cart.items.map(function (l) {
          var img = l.image
            ? '<img src="' + l.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" width="76" height="95" alt="" loading="lazy">'
            : '<span></span>';
          var physical = l.requires_shipping;
          var meta = physical ? (l.variant_title || 'Mask') : 'Added to your order';
          return '<div class="citem">' + img + '<div><b>' + l.product_title + '</b>' +
            '<span class="mono">' + meta + '</span><div class="citem__row">' +
            (physical
              ? '<div class="citem__q">' +
                  '<button type="button" data-k="' + l.key + '" data-q="' + (l.quantity - 1) + '" aria-label="Decrease">&minus;</button>' +
                  '<span>' + l.quantity + '</span>' +
                  '<button type="button" data-k="' + l.key + '" data-q="' + (l.quantity + 1) + '" aria-label="Increase">+</button>' +
                '</div>'
              : '<button type="button" class="citem__rm" data-k="' + l.key + '" data-q="0">Remove</button>') +
            '<span>' + money(l.line_price) + '</span></div></div></div>';
        }).join('');
        $$('[data-k]', body).forEach(function (b) {
          b.addEventListener('click', function () { change(b.dataset.k, parseInt(b.dataset.q, 10)); });
        });
      }
    }
    var sub = $('#cartSub');
    if (sub) sub.textContent = money(cart.total_price);
  }

  function busy(on) {
    var body = $('#cartBody');
    if (body) body.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  function change(key, quantity) {
    busy(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {})
      .then(function () { busy(false); });
  }

  function refresh() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  var co = $('#checkout');
  if (co) co.addEventListener('click', function () { window.location.href = '/checkout'; });

  /* ═══ gallery, wherever one is rendered ════════════════════════ */

  (function () {
    var main = $('#galMain');
    if (!main) return;
    var all = $$('.buy__thumbs button');
    all.forEach(function (b) {
      b.addEventListener('click', function () {
        all.forEach(function (o) { o.classList.remove('is-on'); o.setAttribute('aria-selected', 'false'); o.tabIndex = -1; });
        b.classList.add('is-on'); b.setAttribute('aria-selected', 'true'); b.tabIndex = 0;
        main.classList.add('swap');
        setTimeout(function () { main.src = b.dataset.src; main.classList.remove('swap'); }, 260);
      });
    });
  })();

  /* ═══ the buy panel ════════════════════════════════════════════ */

  if (data) (function () {
    var qty = 1, tier = 'cream', combo = 'CC';

    var variantId = function () { return tier === 'pair' ? data.pair[combo] : data.single[tier]; };
    var unitPrice = function () { return tier === 'pair' ? data.pairPrice : data.singlePrice; };
    var wasPrice  = function () { return tier === 'pair' ? data.pairCompare : 0; };
    var addonsOn  = function () {
      var out = [];
      if ($('#bumpWarranty') && $('#bumpWarranty').checked) out.push({ id: data.warranty, price: data.warrantyPrice });
      if ($('#bumpPriority') && $('#bumpPriority').checked) out.push({ id: data.priority, price: data.priorityPrice });
      return out;
    };

    function paintOffer() {
      var extras = addonsOn().reduce(function (n, a) { return n + a.price; }, 0);
      var now = $('#totalNow'), was = $('#totalWas');
      if (now) now.textContent = money(unitPrice() * qty + extras);
      if (was) {
        var w = wasPrice();
        was.textContent = w ? money(w * qty + extras) : '';
        was.style.display = w ? '' : 'none';
      }
      var picker = $('#comboPick');
      if (picker) picker.hidden = tier !== 'pair';
    }

    $$('input[name="set"]').forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) { tier = r.value; paintOffer(); } });
    });
    $$('input[name="combo"]').forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) { combo = r.value; paintOffer(); } });
    });
    ['#bumpWarranty', '#bumpPriority'].forEach(function (s) {
      if ($(s)) $(s).addEventListener('change', paintOffer);
    });

    var field = $('#qty');
    if (field) {
      var set = function (n) { qty = Math.max(1, Math.min(9, n)); field.value = qty; paintOffer(); };
      if ($('#qtyUp'))   $('#qtyUp').addEventListener('click',   function () { set(qty + 1); });
      if ($('#qtyDown')) $('#qtyDown').addEventListener('click', function () { set(qty - 1); });
    }

    var btn = $('#addBtn');
    if (btn) btn.addEventListener('click', function () {
      var err = $('#buyErr');
      if (err) err.textContent = '';
      var items = [{ id: variantId(), quantity: qty }];
      addonsOn().forEach(function (a) { items.push({ id: a.id, quantity: 1 }); });

      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'That did not go through.');
          btn.classList.add('is-added');
          setTimeout(function () { btn.classList.remove('is-added'); }, 1400);
          refresh();
          setTimeout(function () { if (typeof window.openCart === 'function') window.openCart(); }, 380);
        })
        .catch(function (e) {
          if (err) err.textContent = e.message + ' Refresh the page and try again, or email hello@sorisse.com.';
        })
        .then(function () { btn.disabled = false; });
    });

    paintOffer();
  })();

  refresh();
})();
